import React from 'react';
import AnimatedNumber from 'react-animated-number';
import {Progress, UncontrolledTooltip} from "reactstrap";
import HTML from '../../common/HtmlHelpers';
import PropTypes from 'prop-types';

const CardTile = (props) => {
    
    let id = props.title.replace(/ /g,'')
        .replace(/'/g,'')
        .replace(/\./g,'_')
        .replace(/\(/g,'')
        .replace(/\)/g,'')
        .toLowerCase()
        .trim();

    return (<div className={"card card-click" + (props.classes ? (' ' + props.classes)  : '' ) } id={id} onClick={props.onClick}>
        <div className="card-block">

            <div className="clearfix">

                <div className="pull-left">
                    {/* props.isLoading && <Spinner fadeIn={'half'} color="white" name="pulse"/> */}
                </div>

                <div className="h1 text-muted mb-2 pull-right" >
                    {HTML.renderIcon(props.icon)}
                </div>

            </div>

            <div className="h4 mb-0">{props.preValue} { typeof props.value === "number" ? <AnimatedNumber  value={props.value}
                                                                                                                     duration={props.duration}
                                                                                                                     formatValue={(number) =>  Math.floor(number).toLocaleString('en-us', { minimumFractionDigits: 0 })}
                                                                                                                     style={{
                                                                                                                         transition: '0.8s ease-out',
                                                                                                                         transitionProperty: 'background-color, color, opacity'
                                                                                                                     }}/> : props.value} {props.postValue} </div>
            <small className="text-muted text-uppercase font-weight-bold">{props.title}</small>
            {props.progress && <Progress className="progress progress-white progress-xs mt-1" value={props.progress} />}
        </div>
        {(props.tooltipTitle || props.tooltipContent) && <UncontrolledTooltip key="tip" delay={props.tooltipDelay} autohide={false} fade={false} target={id}>
            <div>
                <h5>{props.tooltipTitle}</h5>
                <p>{props.tooltipContent}</p>
                {props.navigateText && <p><a href="#" onClick={props.onClick} style={{textDecoration: 'underline',color: '#3fe1ec' }}>{props.navigateText}</a></p>  }
            </div>
        </UncontrolledTooltip>}
    </div>);
};

CardTile.propTypes = {
    title: PropTypes.string,
    icon: PropTypes.any,
    classes: PropTypes.string,
    preValue: PropTypes.string,
    postValue: PropTypes.string,
    value: PropTypes.any,
    duration: PropTypes.number,
    progress: PropTypes.number,
    tooltipDelay : PropTypes.number,
    tooltipTitle: PropTypes.string,
    tooltipContent: PropTypes.string,
    onClick: PropTypes.func,
    navigateText: PropTypes.string,
};

CardTile.defaultProps = {
    tooltipDelay: 10,
    duration: 400
};

export  default CardTile;


// WEBPACK FOOTER //
// ./src/components/CardTile/CardTile.js